import type { EnrollmentInfoCertificatesItemCertificateType } from './enrollmentInfoCertificatesItemCertificateType';

export type EnrollmentInfoCertificatesItem = {
  /** 수료증 ID */
  certificateId: string;
  /** 수료증 번호 */
  certificateNumber: string;
  /** 수료증 유형 */
  certificateType?: EnrollmentInfoCertificatesItemCertificateType;
  /** 강좌명 */
  courseName: string;
  /** 수료증 다운로드 URL */
  downloadUrl: string;
  /** 수강신청 ID */
  enrollmentId: string;
  /** 발급 일시 */
  issuedAt: string;
  /** 학생 이름 */
  studentName: string;
  /**
   * 유효 기간
   * @nullable
   */
  validUntil?: string | null;
  /** 수료증 검증 URL */
  verificationUrl: string;
};
